import { Props as DynamicQueryContentProps } from 'components/common/DynamicQueryContent/DynamicQueryContent'

type CatalogueQuery = DynamicQueryContentProps['query']

/**
 * Truthy placeholder while the mutation's own data is reset mid-reprice.
 * The listing renders from the snapshot catalogue held in PurchaseFlowConfig, never from query.data,
 * so the placeholder only keeps DynamicQueryContent's children mounted.
 */
const REPRICE_KEEPALIVE_DATA = {}

/**
 * Masks the raw catalogue mutation state during an embed live reprice.
 *
 * TanStack v5 mutations reset `data` and flip `isPending` on every re-fire, which would make
 * DynamicQueryContent unmount the product cards and flash its spinner on each cart selection.
 * While a reprice is in flight the listing keeps rendering from the snapshot catalogue, so the
 * wrapper must neither show its pending spinner nor drop its children.
 */
export const repriceAwareQuery = (query: CatalogueQuery, isRepricing: boolean): CatalogueQuery => {
  if (!isRepricing) return query

  return {
    ...query,
    isPending: false,
    data: query.data ?? REPRICE_KEEPALIVE_DATA,
  } as CatalogueQuery
}
